import { useEffect, useRef, useCallback, useState } from 'react';

const WS_BASE = process.env.REACT_APP_BACKEND_URL
  .replace('https://', 'wss://')
  .replace('http://', 'ws://');

export const useWebSocket = (token) => {
  const wsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [connected, setConnected] = useState(false);
  const reconnectTimeoutRef = useRef(null);

  const addNotification = useCallback((data) => {
    const notif = { ...data, id: Date.now() + Math.random(), read: false };
    setNotifications(prev => [notif, ...prev].slice(0, 50));
  }, []);

  const clearNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  const markAllRead = useCallback(() => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  }, []);

  const connect = useCallback(() => {
    if (!token || wsRef.current?.readyState === WebSocket.OPEN) return;

    const ws = new WebSocket(`${WS_BASE}/api/ws/${token}`);
    wsRef.current = ws;

    ws.onopen = () => {
      setConnected(true);
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        addNotification(data);
      } catch (e) {
        console.error('WS parse error:', e);
      }
    };

    ws.onclose = () => {
      setConnected(false);
      wsRef.current = null;
      reconnectTimeoutRef.current = setTimeout(connect, 5000);
    };

    ws.onerror = () => {
      ws.close();
    };
  }, [token, addNotification]);

  useEffect(() => {
    connect();
    return () => {
      clearTimeout(reconnectTimeoutRef.current);
      wsRef.current?.close();
    };
  }, [connect]);

  const unreadCount = notifications.filter(n => !n.read).length;

  return { notifications, unreadCount, connected, clearNotification, markAllRead };
};
